import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../properties.service';
import { RequestsService } from '../requests.service';
declare var feather:any;

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit {

  constructor(private properties: PropertiesService, private requests: RequestsService) {
    feather.replace();
    this.properties.currentMessage.subscribe((message: string) => {
      if (message === 'properties-loaded' || message === 'reload-icons') {
        this.requests.getTotalRequests(this.properties.current.hostname).then(success => console.log('loaded total request counts'));
        this.properties.getDNS(this.properties.current.hostname).then(success => console.log('loaded dns'));
      }
    });
   }

  ngOnInit() {
    feather.replace();
  }
  



}
